/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.sherpa.activities.b2c.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers'
])

.controller('SherpaActivitiesB2CController', ['$scope', '$state', 'ApiService', 'HelpersService', function($scope, $state, ApiService, HelpersService) {

    $scope.sherpaActivitiesB2C = {
      activity: [],
      tenantId: '',
      deputyId: '',
      init: function () {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Consumer'
        });

        if ($state.params.hasOwnProperty('tenantId')) {
          $scope.sherpaActivitiesB2C.tenantId = $state.params.tenantId;
        }
        $scope.sherpaActivitiesB2C.getTenantActivity();
      },
      getTenantActivity: function() {
        ApiService.customerService.getTenantB2CActivity($scope.sherpaActivitiesB2C.tenantId, $scope.sherpaActivitiesB2C.deputyId)
          .then($scope.sherpaActivitiesB2C.success.getTenantActivity,$scope.sherpaActivitiesB2C.error.getTenantActivity);
      },
      success: {
        getTenantActivity: function(response) {
          $scope.sherpaActivitiesB2C.activity = response.data.payload;
        }
      },
      error: {
        getTenantActivity: function(response) {
        }
      }
    };
    $scope.sherpaActivitiesB2C.init();

    $scope.gridOptions = {
      multiselect: false,
      enableRowSelection: false,
      paginate: true,
      showFooter: true,
      pageSize: 50,

      columnDefs: [
        {
          field: 'createdOn',
          displayName: 'Date',
          sort: {
            direction: 'desc'
          }
        },
        {
          field: 'activity',
          displayName: 'Activity'
        },
        {
          field: 'logData',
          displayName: 'Data'
        },
        {
          field: 'customerServiceId',
          displayName: 'CSR ID'
        }
      ]
    };

}]);